import {
  ICON_DEFAULT_COLOR,
  ICON_DEFAULT_FILL,
  ICON_DEFAULT_HEIGHT,
  ICON_DEFAULT_VIEWBOX,
  ICON_DEFAULT_WIDTH,
  IconProps
} from 'components'
import { ComponentProps } from 'react'

export const SyncProplem = ({
  color = ICON_DEFAULT_COLOR,
  fill = ICON_DEFAULT_FILL,
  width = ICON_DEFAULT_WIDTH,
  height = ICON_DEFAULT_HEIGHT,
  viewBox = ICON_DEFAULT_VIEWBOX,
  ...props
}: ComponentProps<'svg'> & Omit<IconProps, 'icon'>) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox={viewBox}
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.25 41.6666V37.4999H11.9792L11.1458 36.7708C9.34028 35.1735 8.07292 33.3506 7.34375 31.302C6.61458 29.2534 6.25 27.1874 6.25 25.1041C6.25 21.2499 7.40451 17.8211 9.71354 14.8176C12.0226 11.8142 15.0347 9.82631 18.75 8.85409V13.2291C16.25 14.1319 14.2361 15.6683 12.7083 17.8385C11.1806 20.0086 10.4167 22.4305 10.4167 25.1041C10.4167 26.6666 10.7118 28.1857 11.3021 29.6614C11.8924 31.1371 12.8125 32.4999 14.0625 33.7499L14.5833 34.2708V29.1666H18.75V41.6666H6.25ZM25 35.4166C24.4097 35.4166 23.9149 35.2169 23.5156 34.8176C23.1163 34.4183 22.9167 33.9235 22.9167 33.3333C22.9167 32.743 23.1163 32.2482 23.5156 31.8489C23.9149 31.4496 24.4097 31.2499 25 31.2499C25.5903 31.2499 26.0851 31.4496 26.4844 31.8489C26.8837 32.2482 27.0833 32.743 27.0833 33.3333C27.0833 33.9235 26.8837 34.4183 26.4844 34.8176C26.0851 35.2169 25.5903 35.4166 25 35.4166ZM22.9167 27.0833V14.5833H27.0833V27.0833H22.9167ZM31.25 41.1458V36.7708C33.75 35.868 35.7639 34.3315 37.2917 32.1614C38.8194 29.9912 39.5833 27.5694 39.5833 24.8958C39.5833 23.3333 39.2882 21.8142 38.6979 20.3385C38.1076 18.8628 37.1875 17.4999 35.9375 16.2499L35.4167 15.7291V20.8333H31.25V8.33325H43.75V12.4999H38.0208L38.8542 13.2291C40.5556 14.9305 41.7969 16.7794 42.5781 18.776C43.3594 20.7725 43.75 22.8124 43.75 24.8958C43.75 28.7499 42.5955 32.1787 40.2865 35.1822C37.9774 38.1857 34.9653 40.1735 31.25 41.1458Z"
        fill={color}
      />
    </svg>
  )
}
